import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  isAdminSelector,
  devicesSelector,
  itemsSelector,
  pathSelector,
  channelsSelector,
  deviceModelsSelector,
} from '../selectors';
import { onFetchRealtimeDatas } from '../actions/entry';
import ReportDevices from '../components/ReportDevices';

const mapStateToProps = (state) => {
  const { deviceId } = pathSelector(state);
  const isAdmin = isAdminSelector(state);
  let devices = devicesSelector(state);
  const items = itemsSelector(state);
  const channels = channelsSelector(state);
  const models = deviceModelsSelector(state);
  const { data } = state.realtimeDatas;

  devices = devices.map((device) => {
    const isError = device.status !== 0;
    return {
      isError,
      ...device,
    };
  });

  let realtimeDatas = [];
  if (data) {
    realtimeDatas = data.map((d) => {
      return {
        ...d,
        isError: d.status !== 0,
      };
    });
  }

  const { reports } = state;

  // logic device
  const logicDatas = {};
  devices.map(async (dv) => {
    if (data && dv.logicDevice) {
      const itemsDeviceList = [];
      let status = 0;
      let loggedAt = '';
      if (!(dv.id in logicDatas)) {
        logicDatas[dv.id] = { ...dv, deviceId: dv.id, values: {}, isError: false };
      }
      items
        .filter((f) => f.modelId === dv.modelId)
        .forEach((it) => {
          let itemValue;
          if (it.isIntegral || it.isSum) {
            dv.deviceIds.forEach((did) => {
              data.forEach((deviceItem) => {
                if (deviceItem.deviceId === did) {
                  if (deviceItem.values && !Number.isNaN(deviceItem.values?.[it.itemName] * 1)) {
                    if (Number.isNaN(itemValue * 1)) {
                      itemValue = 0;
                    }
                    itemValue += deviceItem.values[it.itemName] * 1;
                  }
                  if (deviceItem.status !== 0) {
                    status = deviceItem.status;
                  }
                  if (loggedAt < deviceItem.loggedAt) {
                    loggedAt = deviceItem.loggedAt;
                  }
                }
              });
            });
          } else {
            data.forEach((deviceItem) => {
              if (deviceItem.deviceId === dv.deviceIds[0]) {
                if (!Number.isNaN(deviceItem.values?.[it.itemName] * 1)) {
                  itemValue = deviceItem.values[it.itemName] * 1;
                }
                if (deviceItem.status !== 0) {
                  status = deviceItem.status;
                }
                if (loggedAt < deviceItem.loggedAt) {
                  loggedAt = deviceItem.loggedAt;
                }
              }
            });
          }
          if (!Number.isNaN(itemValue * 1)) {
            itemsDeviceList.push({ [it.itemName]: itemValue });
          }
        });

      const itemsDevice = itemsDeviceList.reduce((result, item) => {
        const key = Object.keys(item)[0];
        // eslint-disable-next-line no-param-reassign
        result[key] = item[key];
        return result;
      }, {});

      logicDatas[dv.id].values = itemsDevice;
      logicDatas[dv.id].status = status;
      logicDatas[dv.id].isError = status !== 0;
      logicDatas[dv.id].loggedAt = loggedAt;
      realtimeDatas.push(logicDatas[dv.id]);
    }
  });

  return {
    realtimeDatas,
    updatedAt: reports.updatedAt || new Date(),
    channels,
    models,
    items,
    devices,
    isEditable: isAdmin,
    isDeviceModalOpened: !!deviceId,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchRealtimeDatas,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ReportDevices);
